var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.81332 7.2479C3.58932 7.2479 3.36532 7.1629 3.19432 6.9919L0.821319 4.6189C0.479319 4.2769 0.479319 3.7229 0.821319 3.3819C1.16332 3.0399 1.71632 3.0389 2.05832 3.3809L3.81332 5.1359L7.94132 1.0079C8.28332 0.665904 8.83632 0.665904 9.17832 1.0079C9.52032 1.3499 9.52032 1.9039 9.17832 2.2459L4.43232 6.9919C4.26132 7.1629 4.03732 7.2479 3.81332 7.2479Z",
    fill: "#130F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.5dcd0cc58e36085779d8744ba30404b3.svg";
export { ForwardRef as ReactComponent };